<template>
  <div class="search-form">
    <div class="d-flex">
      <div style="width:400px;" class="mb-2">
        <b-input-group size="sm">
          <b-form-input
            @keyup.enter="query"
            type="search"
            v-model.trim="form.keyword"
            placeholder="订单编号/客户/合同名称/发货城市/发货方/收货城市/收货方搜索..."
          />
          <b-input-group-append>
            <b-button-group>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  高级搜索
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-button-group>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="mb-2">
        <b-input-group size="sm">
          <b-button
            v-allow="'actCancelBill'"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="batchSumit()"
            >账单回退
          </b-button>
        </b-input-group>
      </div>
    </div>

    <el-dialog
      title="高级搜索"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      v-el-dialog-drag
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-form-item label="订单编号">
            <el-input
              v-model.trim="form.orderNo"
              placeholder="请输入订单编号"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="结算单号">
            <el-input
              v-model.trim="form.settlementNo"
              placeholder="请输入结算单号"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="始发地省份">
            <el-input
              v-model.trim="form.originProvinceName"
              placeholder="请输入始发地省份"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="始发地发货方">
            <el-input
              v-model.trim="form.originName"
              placeholder="请输入始发地发货方"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="目的地省份">
            <el-input
              v-model.trim="form.destinationProvinceName"
              placeholder="请输入目的地省份"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="目的地收货方">
            <el-input
              v-model.trim="form.destinationName"
              placeholder="请输入目的地收货方"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          取消查询
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          重置条件
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          数据检索
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  incomeFreightStatusList: ['Y'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    batchSumit() {
      this.$emit('batchSumit')
    },
  },
}
</script>
